module.exports = __webpack_public_path__ + "static/media/4.8e425f4a.jpg";